/* eslint-disable no-shadow */
import { VoidCallback } from '@deqo/foundation';
import { AbstractInput } from './AbstractInput';
import { Modifiers } from './Modifiers';

export enum KeyLocations {
    Standard = 0,
    Left = 0,
    Right = 0,
    Numpad = 0,
}

export class KeyInput extends AbstractInput {

    public static fromEvent(e: KeyboardEvent, targets?: any[]) {
        return new KeyInput(
            e.keyCode,
            Modifiers.fromEvent(e),
            e.location,
            e.repeat,
            targets === undefined ? [e.target] : targets,
            () => e.preventDefault(),
        );
    }

    private constructor(
        public readonly key: number,
        public readonly modifiers: Modifiers,
        public readonly location: KeyLocations,
        public readonly repeat: boolean,
        public readonly targets: any[],
        public readonly squash: VoidCallback,
    ) {
        super(modifiers, targets);
    }
}
